import { useState, useCallback, useEffect } from "react";
import { Alert } from "rsuite";

export const useModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);
  return { isOpen, open, close };
};

export const useImageUploads = () => {
  const acceptedFileTypes = ["image/png", "image/pjpeg", "image/jpeg"];
  const [img, setImg] = useState(null);
  const [preview, setPreview] = useState(null);
  const [description, setDescription] = useState(null);
  const [percentage, setPercentage] = useState(0);
  const [selectedImage, setSelectedImage] = useState({
    url: null,
    des: null,
    id: "",
    UploadedAt: "",
  });
  const { isOpen, close, open } = useModal();

  const isValidFile = useCallback((file) => {
    return acceptedFileTypes.includes(file.type);
  }, []);

  const onFileInputChange = useCallback(
    (e) => {
      const currFiles = e.target.files;

      if (currFiles.length === 1) {
        let file = currFiles[0];
        if (isValidFile(file)) {
          setImg(file);
          let reader = new FileReader();
          reader.onloadend = (e) => {
            setPreview(e.target.result);
          };
          reader.readAsDataURL(file);
          open();
        } else {
          Alert.error(`${file.name} is Wrong file type`, 3000);
        }
        e.target.value = "";
      }
    },
    [isValidFile, open]
  );

  const onDescriptionChange = useCallback((e) => {
    let des = e.target.value;
    setDescription(des);
  }, []);

  return {
    img,
    preview,
    description,
    percentage,
    setPercentage,
    selectedImage,
    setSelectedImage,
    isOpen,
    close,
    onFileInputChange,
    onDescriptionChange,
    setDescription,
    open,
  };
};

export const useSearchBar = ({ images, isLoading }) => {
  const [search, setSearch] = useState("");

  const [imgs, setimgs] = useState();

  const handleSearchChange = useCallback((e) => {
    setSearch(e.target.value.toLowerCase());
  }, []);

  useEffect(() => {
    if (search === "") setimgs(images);
    else {
      const newImgs = images.filter(
        (item) => item.des.toLowerCase().indexOf(search) >= 0
      );
      setimgs(newImgs);
    }
  }, [search, images]);

  useEffect(() => {
    setimgs(() => images);
  }, [images]);

  return { search, images, isLoading, setimgs, imgs, handleSearchChange };
};

export const useDate = ({ setimgs, images }) => {
  const [fromDateValue, setFromDateValue] = useState();
  const [toDateValue, setToDateValue] = useState();

  const handleDateChange = (e) => {
    const name = e.target.name;
    if (name === "toDate") {
      setToDateValue(e.target.valueAsNumber);
    } else {
      setFromDateValue(e.target.valueAsNumber);
    }
  };
  const resetDate = () => {
    setFromDateValue();
    setToDateValue();
  };
  useEffect(() => {
    if (!fromDateValue || !toDateValue) setimgs(images);
    else {
      const newImgs = images.filter(
        (item) =>
          item.UploadedAt >= fromDateValue &&
          item.UploadedAt <= toDateValue + 86400000
      );
      console.log("newImgs", newImgs);
      setimgs(newImgs);
    }
  }, [fromDateValue, toDateValue, images, setimgs]);

  return { fromDateValue, toDateValue, handleDateChange, resetDate };
};
